import {REQUEST_METHOD} from "../../../shared/utils/helper";
import {makeServerRequest} from "./server-request";
import {QUIZ_BASE_URL} from "../../../shared/utils/quiz-api-services";
import {makeQuizServerRequest} from "../quiz-admin-api-services/quiz-server-request";

export const adminSignIn = (successFunction, failureFunction) => {
    const data = JSON.stringify({
        username: 'shmaster',
        password: 'uTb8ZUtKGA_qpTVv'
    })
    makeServerRequest('/adminsignin', REQUEST_METHOD.POST, data, successFunction, failureFunction)
    makeQuizServerRequest(QUIZ_BASE_URL + '/adminsignin', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const validateAdminUser = (userId, successFunction, failureFunction) => {
    const data = JSON.stringify({
        'user_id': userId
    })
    makeServerRequest('/validateadminuser', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const getAdminUserRole = (userId, successFunction, failureFunction) => {
    const data = JSON.stringify({
        'user_id': userId
    })
    makeServerRequest('/getadminuserrole', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const getAllAdminUsers = (userId, successFunction, failureFunction) => {
    const data = JSON.stringify({
        'user_id': userId
    })
    makeServerRequest('/getadminusers', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const createAdminUser = (userId, role, successFunction, failureFunction) => {
    const data = JSON.stringify({
        "user_id": userId,
        "role": role
    })
    makeServerRequest('/createadminuser', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const updateAdminUser = (userId, role, successFunction, failureFunction) => {
    const data = JSON.stringify({
        "user_id": userId,
        "role": role
    })
    makeServerRequest('/updateadminuser', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const deleteAdminUser = (userId, successFunction, failureFunction) => {
    const data = JSON.stringify({
        "user_id": userId,
    })
    makeServerRequest('/deleteadminuser', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}
